import axios from "axios";

const instance = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	// timeout: 1000,
	headers: {}
});

export default component => {
	if (component.$root.store.state.currentToken) {
		instance.defaults.headers.authorization =
			"Bearer " + component.$root.store.state.currentToken;

		instance.interceptors.response.use(
			response => {
				return response;
			},
			error => {
				if (error?.response?.status === 406) {
					component.$root.showAlert(error.response?.data?.error, {
						title: "Error de permisos",
						variant: "danger"
					});
				}
				return Promise.reject(error);
			}
		);
	}
	return instance;
};
// instance
